export default "__VITE_ASSET__Dx_QPxH7__"